import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { GenericPaginated } from '../../models/generic-paginated';
import { Generic } from '../../models/generic';
import { OperationSubmission, OperationSubmissionStats } from '../../models/operation-submission';

@Injectable({
  providedIn: 'root'
})
export class OperationSubmissionService {

  private baseUrl = `${environment.url}/operation-submissions`;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getOperationSubmissions(params?: Params): Observable<GenericPaginated<OperationSubmission>> {
    return this.http.get<GenericPaginated<OperationSubmission>>(this.baseUrl, {
      params: this.addParamsService.addParams(params)
    });
  }

  getOperationSubmissionById(id: number): Observable<Generic<OperationSubmission>> {
    return this.http.get<Generic<OperationSubmission>>(`${this.baseUrl}/${id}`);
  }

  getStatistics(): Observable<Generic<OperationSubmissionStats>> {
    return this.http.get<Generic<OperationSubmissionStats>>(`${this.baseUrl}/statistics`);
  }

  approve(id: number, payload: { comment?: string } = {}): Observable<Generic<OperationSubmission>> {
    return this.http.post<Generic<OperationSubmission>>(`${this.baseUrl}/${id}/approve`, payload);
  }

  reject(id: number, payload: { comment?: string } = {}): Observable<Generic<OperationSubmission>> {
    return this.http.post<Generic<OperationSubmission>>(`${this.baseUrl}/${id}/reject`, payload);
  }

  updateStatus(id: number, payload: { status: string; comment?: string }): Observable<Generic<OperationSubmission>> {
    return this.http.post<Generic<OperationSubmission>>(`${this.baseUrl}/${id}/status`, payload);
  }
}
